import React from "react";
import { connect } from "react-redux";
import { getDocumentoEstadisticas, dataLayerTag } from "../functions";

class DocumentoEstadisticasPlanMovilidad extends React.PureComponent {
  render() {
    return (
      <div className="row">
        <div className="col-sm-9 text-left">
          <div className="PM-cuadro-3">
            <h5><strong>Presenta los resultados del informe de Diagnóstico a tu organización.</strong></h5>
            <p>Si necesitas acceder nuevamente al informe y medidas puedes descargarlo aquí.</p>
          </div>
        </div>
        <div className="col-sm-3 btn-material">
          <button
            className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
            onClick={() => {
              getDocumentoEstadisticas(this.props.idplanMovilidad);
              // gtd -> genera informe estadistico
              dataLayerTag({
                'event': 'etapa_3_descarga_informe_estadistico',
                'etapa': '3'
              });
            }}
            disabled={this.props.estadoProceso < 3}
          >Informe de Diagnóstico</button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  estadoProceso: state.planMovilidad.estadoProceso,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentoEstadisticasPlanMovilidad);
